import { ApiProperty } from "@nestjs/swagger";

export class PalletRequest{
    @ApiProperty()
    palletId:number;
}